export const BASE_URL =
  window.location.hostname === "localhost"
    ? "http://localhost:5000/api/"
    : `${window.location.protocol}//${window.location.host}/api/`;
